import { useState, useEffect } from "react";
import GalleryViewer from "../components/Gallery/GalleryViewer";
//import { GALLERY_IMAGES } from "../data/GalleryData.js";

function GalleryPage() {
  useEffect(() => {
    const tt = GALLERY_IMAGES;
    //setGalleryImages(tt);

  }, []);

  const GALLERY_IMAGES = Array.from({ length: 38 }, (_, i) => ({
    id: i + 1,
    category: "Gallery",
    image: `/assets/gallery/${String(i + 1).padStart(3, "0")}.jpg`,
  }));

  return <GalleryViewer images={GALLERY_IMAGES} />;
}

export default GalleryPage;
